import { Checkbox, DatePicker, Flex, Radio } from "antd"
import dayjs from "dayjs"
import { BRAZILIAN_CREDIT_BONDS_TYPE, useBrazilianCreditBonds } from "../../../hooks/useBrazilianCreditBonds"
import { spaces } from "../../../utils/styles"
import { BrazilianCreditBondsPlot } from "../../molecules/charts/BrazilianCreditBondsPlot"
import { useState } from "react"

export const BrazilianCreditBonds = () => {
  const { date, setDate, filterType, setFilterType, availableDates, result, ipcaCurve } = useBrazilianCreditBonds()

  const [showOnlyBondsWithSpreadOverIPCA, setShowOnlyBondsWithSpreadOverIPCA] = useState(false)

  const getBondsFiltered = () =>
    result.filter((item) => {
      if (!showOnlyBondsWithSpreadOverIPCA || !ipcaCurve || !ipcaCurve.length || filterType.value !== BRAZILIAN_CREDIT_BONDS_TYPE[2].value)
        return true

      const previous = ipcaCurve.reduce(
        (prev, curr) => {
          return curr.duration < item.duration && curr.duration > prev.duration ? curr : prev
        },
        { duration: 0, rate: 0 },
      )

      const next = ipcaCurve.reduce(
        (prev, curr) => {
          return curr.duration > item.duration && curr.duration < prev.duration ? curr : prev
        },
        { duration: Infinity, rate: 0 },
      )

      if (!previous.duration && !previous.duration) return false

      const interpolation = previous.rate + ((next.rate - previous.rate) / (next.duration - previous.duration)) * (item.duration - previous.duration)

      return item.rate > interpolation
    })

  return (
    <Flex vertical style={{ padding: spaces.space1 }}>
      <Flex style={{ alignItems: "center", gap: spaces.space2 }}>
        <DatePicker
          onChange={(date) => setDate(date.format("YYYY-MM-DD"))}
          value={dayjs(date)}
          disabledDate={(current) => !availableDates.includes(current.format("YYYY-MM-DD"))}
          allowClear={false}
        />
        <Radio.Group defaultValue={filterType} onChange={(e) => setFilterType(e.target.value)}>
          {BRAZILIAN_CREDIT_BONDS_TYPE.map((item) => (
            <Radio value={item}>{item.label}</Radio>
          ))}
        </Radio.Group>

        {filterType.value === BRAZILIAN_CREDIT_BONDS_TYPE[2].value && (
          <Checkbox checked={showOnlyBondsWithSpreadOverIPCA} onChange={(e) => setShowOnlyBondsWithSpreadOverIPCA(e.target.checked)}>
            Show only bonds with spread over IPCA
          </Checkbox>
        )}

        <Flex style={{ marginLeft: spaces.space1, gap: spaces.space1 }}>
          <b>Bonds count:</b>
          {getBondsFiltered().length}
        </Flex>
      </Flex>
      <Flex style={{ marginLeft: spaces.space1 }}>
        <BrazilianCreditBondsPlot data={getBondsFiltered()} legend={filterType.legend} comparativeCurves={[{ IPCA: ipcaCurve }]} />
      </Flex>
    </Flex>
  )
}
